import { render, staticRenderFns } from "./TopBarMenu.vue?vue&type=template&id=64a521f5&"
import script from "./TopBarMenu.vue?vue&type=script&lang=ts&"
export * from "./TopBarMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports